(function () {
    'use strict';

    angular.module('finansApp.courseSortService', []).factory('courseSortService', courseSortService);
    

    function State() {
        this.sortOrder = "date-asc";
        this.options = {
            "name-asc": "Navn stigende",
            "name-desc": "Navn faldende",
            "date-asc": "Dato stigende",
            "date-desc": "Dato faldende"
        };
    }

    courseSortService.$inject = ['$filter', '$q', '$location'];

    function courseSortService($filter, $q, $location) {
        var state = new State(); 


        // Public
        var service = {
            state: state,
            sortCourses: sortCourses,
            setUrl: setUrl
        };

        function sortCourses(arr) {
            var deferred = $q.defer(); 

            if(state.sortOrder == "name-asc") {
                arr = $filter('orderBy')(arr, 'CourseHeadline');
            }
            else if (state.sortOrder == "name-desc") {
                arr = $filter('orderBy')(arr, '-CourseHeadline');
            }
                //Date Asc and Date Desc have similar logic, but the orderby on date. 
            else if (state.sortOrder == "date-asc") {
                arr = reArrangeArrayBasedOnSortDate(arr, 'CourseDate', 'CourseHeadline');
            }
            else if (state.sortOrder == "date-desc") {
                arr = reArrangeArrayBasedOnSortDate(arr, '-CourseDate', 'CourseHeadline');
            }
            else {
                arr = $filter('orderBy')(arr, 'CourseDate');
            }

            deferred.resolve(arr);
            
            return deferred.promise;
        }

        function reArrangeArrayBasedOnSortDate(arr, comparatorExpressionDate, comparatorExpressionName) {
            var hasDateDateAsc = []; // A temp holder for the items with a date
            var noDateButElearningAsc = []; // A temp holder for the items without a date but E-learning
            var noDateNotElearningAsc = []; // A temp holder for the items without a date
            arr.forEach(function (element) {

                if (element.CourseDate == null) {
                    if (element.isElearning) {
                        noDateButElearningAsc.push(element);
                    } else {
                        noDateNotElearningAsc.push(element);
                    }
                    
                } else {
                    hasDateDateAsc.push(element);
                }
            });

            //console.log(arr);
            //console.log(hasDateDateAsc);
            //console.log(noDateButElearningAsc);
            //console.log(noDateNotElearningAsc);

            hasDateDateAsc = $filter('orderBy')(hasDateDateAsc, comparatorExpressionDate);
            noDateButElearningAsc = $filter('orderBy')(noDateButElearningAsc, 'CourseHeadline');
            noDateNotElearningAsc = $filter('orderBy')(noDateNotElearningAsc, comparatorExpressionName);

            arr = hasDateDateAsc.concat(noDateButElearningAsc).concat(noDateNotElearningAsc);

            //console.log(arr);
            //arr = hasDateDateAsc.concat(noDateNotElearningAsc);
            return arr;
        }

        function setUrl() {
           var params = $location.search();

            if(typeof state.sortOrder !== 'undefined' && state.sortOrder) {
                params.sort = state.sortOrder;
            }

            $location.search(params);

        }

                // Helper method to check if a array contains a value
        var contains = function(needle) {
            // Per spec, the way to identify NaN is that it is not equal to itself
            var findNaN = needle !== needle;
            var indexOf;

            if(!findNaN && typeof Array.prototype.indexOf === 'function') {
                indexOf = Array.prototype.indexOf;
            } else {
                indexOf = function(needle) {
                    var i = -1, index = -1;

                    for(i = 0; i < this.length; i++) {
                        var item = this[i];

                        if((findNaN && item !== item) || item === needle) {
                            index = i;
                            break;
                        }
                    }

                    return index;
                };
            }

            return indexOf.call(this, needle) > -1;
        };
        
        return service;



    }

})();

